export const DOCUMENT_TYPE_WINDOW_CONTENT = 'windowContent';
export const WINDOW_CONFIGURATOR_PATH = '/konfigurator/vindu';
